
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/smart-generator",
      function () {
        return require("private-next-pages/smart-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/smart-generator"])
      });
    }
  